import { Box, ColorOptions, ModBox, useWindowDimensions } from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/native'
import { FC, useEffect } from 'react'
import { SvgImage } from '../../comps/SvgImage'
import { loginStrings } from '../../data/static/strings'
import { useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { useIsMobile } from '../../util/useFontSize'
import { Colors, getFromStore } from '../../util/util'
import { LoginBg } from './LoginBg'
import LoginCard from './LoginCard'
import LoginCardMobileWeb from './LoginCard/LoginCardMobileWeb'
import { styles } from './styles'

let mobileNumber = ''
// let otpGiven = ''

const Login: FC = ({ route }: any) => {
  const { updateMobile, updateSession } = useStores((root) => ({
    mobileNum: root.settings.metaData.mobileNumber,
    isAppLockEnabled: root.settings.metaData.isAppLockEnabled,
    sessionData: root.user.session,
    updateMobile: root.settings.metaData.updateMobileNumber,
    updateSession: root?.user?.session?.updateSessionData,
    setAppLockEnabled: root.settings.metaData.setAppLockEnabled,
  }))
  const path = route?.params?.path ?? Routes.LOGIN
  const pathName = useRoute().name
  const deeplinkPath = route?.params?.navigateTo
  const isFlowSignup = pathName === Routes.SIGNUP ?? false
  // console.log('Current Login / Signup isSignup', isFlowSignup, path)

  const getFromLocal = () => {
    getFromStore('sessionData').then((value) => {
      if (value !== null) {
        const jsonValue = JSON.parse(value)
        // const obj = JSON.parse(jsonValue)
        updateSession(jsonValue)
      }
    })
    getFromStore(loginStrings.userMobileNumber).then((value) => {
      if (value !== null) {
        const jsonValue = JSON.parse(value)
        updateMobile(jsonValue)
      }
    })
  }

  useEffect(() => {
    getFromLocal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const enteredMobileNumber = (mobile: string): void => {
    mobileNumber = mobile
    updateMobile(mobileNumber)
  }

  const isMobile = useIsMobile()
  const viewPortWidth = useWindowDimensions()
  const themedStyle = styles(viewPortWidth)
  const navigation = useNavigation()
  if (isMobile) {
    return (
      <Box w={'100%'}>
        <Box w={'100%'} h={64} ph={16} justify={'center'} bg={Colors.SECONDARY as ColorOptions}>
          <ModBox
            testID="back-arrow"
            onPress={() => navigation?.canGoBack() && navigation.goBack()}
            underlayColor="TRANSPARENT">
            <SvgImage imageName="HeaderArrowLeft" />
          </ModBox>
        </Box>
        <Box marginTop={0} h={'calc(100vh - 64px)'} bg={Colors.SECONDARY as ColorOptions}>
          <Box
            {...themedStyle.card}
            borderBottomLeftRadius={0}
            borderBottomRightRadius={0}
            borderTopLeftRadius={24}
            borderTopRightRadius={24}
            h={'calc(100vh - 64px)'}>
            <LoginCardMobileWeb hide={false} getMobileNumber={enteredMobileNumber} />
          </Box>
        </Box>
      </Box>
    )
  }
  return (
    <LoginBg isSignup={false}>
      <LoginCard hide={false} getMobileNumber={enteredMobileNumber} deeplinkPath={deeplinkPath} />
    </LoginBg>
  )
}

export default Login
